import AnnouncementBubble from '../atoms/announcementBubble'


const Announcements = ({ announcements }) => {
  return (
    <div className="mb-8">
      <p className="text-lg font-medium text-primary mb-4 whitespace-pre-line">Announcements</p>
      {Object.keys(announcements).map(function(key)  {
        return (<AnnouncementBubble key={key+ announcements[key].title} title={announcements[key].title} message={announcements[key].message} />)
      })
    }
    </div>
  )
}

export default Announcements
